<!--联系人-->
<template>
  <div>
    <fy_header></fy_header>
    <fy_banner></fy_banner>
    <fy_brief></fy_brief>
    <fy_map></fy_map>
    <fy_container_contact v-for="(item,index) in productList" :product="item" :key="index"></fy_container_contact>
    <fy_footer></fy_footer>
  </div>
</template>

<script>
    import fy_header from "../components/fy_header"
    import fy_banner from "../components/fy_banner"
    import fy_map from "../components/fy_map"
    import fy_container_contact from "../components/fy_container_contact"
    import fy_footer from "../components/fy_footer"
    import fy_brief from "../components/fy_brief"

    import productList from "../assets/conf/contact"
    export default {
        name: "contact",
        components: {
            fy_header,
            fy_banner,
            fy_map,
            fy_container_contact,
            fy_footer,
            fy_brief
        },
        data() {
            return {
                productList,
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/contact.vue